<template>
    <div>
        <!-- 特色设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.menu.featuredSettings")}}</span>
        <span class="tips-text2">*{{
          $t("message.messageMsg.featureMsg") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.touchScreenGloveMode") }}</span>
        <el-select size="medium" v-model="FeatureSettings.glove_mode.value" >
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.DoubleClickWakeUpScreen") }} </span>
        <el-select size="medium" v-model="FeatureSettings.double_click_awake_screen.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{
        $t("message.featrueSettingMsg.disableStatusBarDropdown")
      }}</span>
        <el-select size="medium" v-model="FeatureSettings.drop_down.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.hideSoftKeyboard") }}</span>
        <el-select size="medium" v-model="FeatureSettings.softinput.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.shieldVirtualKey1") }}</span>
        <el-select size="medium" v-model="FeatureSettings.vkey1_disabled.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.shieldVirtualKey2") }}</span>
        <el-select size="medium" v-model="FeatureSettings.vkey2_disabled.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.shieldVirtualKey3") }}</span>
        <el-select size="medium" v-model="FeatureSettings.vkey3_disabled.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.prohibitedAppKey") }}</span>
        <el-select size="medium" v-model="FeatureSettings.scankey_code.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.displayScanHoverButton") }}
        </span>
        <el-select size="medium" v-model="FeatureSettings.scan_float.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.getDeviceId") }}</span>
        <el-select size="medium" v-model="FeatureSettings.force_imei.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.noDropDetection") }}</span>
        <el-select size="medium" v-model="FeatureSettings.drop_detection_disabled.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.installAppUnknown") }}</span>
        <el-select size="medium" v-model="FeatureSettings.allow_install_apps.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.noPwdEnter") }}</span>
        <el-select size="medium" v-model="FeatureSettings.developer_no_password.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.FnkeyStickingPrimaryMode") }}</span>
        <el-select size="medium" v-model="FeatureSettings.keypad_mode_stick_once.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.shieldingP5FunctionKey") }}</span>
        <el-select size="medium" v-model="FeatureSettings.P5_disable.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>

      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.shieldingP7FunctionKey") }}</span>
        <el-select size="medium" v-model="FeatureSettings.P7_disable.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.recentToMenu") }}</span>
        <el-select size="medium" v-model="FeatureSettings.recent_transfer_menu.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.shieldedHardKeyboardHOMEKey") }}</span>
        <el-select size="medium" v-model="FeatureSettings.disable_key_home.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.shieldLockScreenKey") }}</span>
        <el-select size="medium" v-model="FeatureSettings.disable_key_lockscreen.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.automaticallyRestart") }}</span>
        <el-select size="medium"  v-model="FeatureSettings.install_no_market_apps.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.hardKeyboardPromptTone") }}</span>
        <el-select size="medium" v-model="FeatureSettings.keypadsound.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>

      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.installUnknown") }}</span>
        <el-select size="medium" v-model="FeatureSettings.allow_document_install_apps.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.fixedChargingMode") }}</span>
        <el-select size="medium" v-model="FeatureSettings.fixed_charge_mode.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.wakeUpScanKey") }}</span>
        <el-select size="medium" v-model="FeatureSettings.scankey_awake_scan.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.wakeUpScreen") }}</span>
        <el-select size="medium" v-model="FeatureSettings.scankey_awake_screen.value" >
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.wakeUpDevice") }}</span>
        <el-select size="medium" v-model="FeatureSettings.wake_gesture_enable.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.voiceKeyEnable") }}</span>
        <el-select size="medium" v-model="FeatureSettings.voice_enable.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.USBChargingOnly") }}</span>
        <el-select size="medium" v-model="FeatureSettings.usb_only_charge.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.supportRotation") }}</span>
        <el-select size="medium" v-model="FeatureSettings.screen_all_rotation.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.applyCompatibilityMode") }}</span>
        <el-select size="medium" v-model="FeatureSettings.app_compatibility.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.focusModeEnhancement") }}</span>
        <el-select size="medium" v-model="FeatureSettings.scan_focus_mode_enhance.value">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box2">
        <span class="setTitle">{{ $t("message.featrueSettingMsg.customizeFunctionKeySettings.title") }}</span>
        <el-select size="medium"  v-model="FeatureSettings.custom_button.value">
          <el-option :label="$t('message.featrueSettingMsg.customizeFunctionKeySettings.nothing')"
            value="0"></el-option>
          <el-option :label="$t('message.featrueSettingMsg.customizeFunctionKeySettings.flashlight')"
            value="1"></el-option>
          <el-option :label="$t('message.featrueSettingMsg.customizeFunctionKeySettings.pupilLamp')"
            value="2"></el-option>
        </el-select>
      </el-col>
    </el-row>
    </div>
</template>
<script>
export default {
  name: "FeatureSetting",
  props: {
    featuredSetNoFilter: {
      type: Object
    }
  },
  data() {
    return {
     
    };
  },
  computed: {
    valueChange() {
      let value = 0
      for (var key in this.FeatureSettings) {
        value += this.FeatureSettings[key].value
      }
      return value
    },
    FeatureSettings(){
      return this.featuredSetNoFilter
    }
  },
  watch: {
    valueChange: {
    handler() {
      this.createLocalStorageData();
    },
    immediate: true
    }
  },
  methods: {
    createLocalStorageData() {
      const filteredSettings = Object.entries(this.FeatureSettings)
        .filter(([key, value]) => value.value !== null)
        .reduce((acc, [key, value]) => {
          acc[key] = value; // 只包含value不为null的属性
          return acc;
        }, {});
      // 将过滤后的设置保存到localStorage
      this.$emit('update:featuredSetFilter', filteredSettings);
      //将未过滤的设置保存到localStorage
      this.$emit('update:featuredSetNoFilter',this.FeatureSettings);


      // 自定义存储数据
       // 将过滤后的设置保存到localStorage
       this.$emit('update:config-featuredSetFilter',filteredSettings);
      //将未过滤的设置保存到localStorage
      this.$emit('update:config-featuredSetNoFilter',this.FeatureSettings);
    },
      // 数据回显
      updateFeatureSettings(originalSettings, updatedSettings) {
        // 遍历 updatedSettings 中的每一个属性
        for (const key in updatedSettings) {
          // 如果 originalSettings 中也存在这个属性
          if (originalSettings.hasOwnProperty(key)) {
            // 并且 updatedSettings 中该属性的 value 不是 null
            if (updatedSettings[key].value !== null) {
              // 则更新 originalSettings 中对应属性的 value
              originalSettings[key].value = updatedSettings[key].value;
            }
          }
        }
        // 返回更新后的 originalSettings（可选，因为原始对象被直接修改）
        return originalSettings;
      },
  },
};
</script>